import { useClient } from "~/composables/client";
import type { UserFeatureKey } from "api/modules/users/features/features.defaults";

export const useUserFeatures = async () => {
  const client = useClient();
  const result = await client.user.features.get.query();

  const isEnabled = (key: UserFeatureKey): boolean => {
    return result?.[key] ?? false;
  };

  return { ...result, isEnabled };
};

export const useUserFeature = async (key: UserFeatureKey) => {
  const client = useClient();
  const result = await client.user.features.isEnabled.query({ key });

  return result;
};
